
// Root component
import App from './App';

// Console
import ConsoleComponents from './console/ConsoleComponents';
import ConsoleConfiguration from './console/ConsoleConfiguration';
import ConsoleModels from './console/ConsoleModels';
import ConsolePlugins from './console/ConsolePlugins';
import ConsoleServices from './console/ConsoleServices';
import ConsoleVuex from './console/ConsoleVuex';

// Containers
import Card from './containers/Card';
import Page from './containers/Page';
import Panel from './containers/Panel';
import PanelContent from './containers/PanelContent';

// Controls
import Click from './controls/Click';
import ClickButton from './controls/ClickButton';
import IconButton from './controls/IconButton';
import Set from './controls/Set';
import Slider from './controls/Slider';
import Textinput from './controls/Textinput';
import Toggle from './controls/Toggle';

// Counters
import Counter from './counters/Counter';
import GlobalCounterIterator from './counters/GlobalCounterIterator';
import LocalCounter from './counters/LocalCounter';

// Forms
import Checkbox from './forms/Checkbox';
import Checkmark from './forms/Checkmark';
import Flipswitch from './forms/Flipswitch';
import Radio from './forms/Radio';

// Layout
import Notification from './layout/Notification';
import Panels from './layout/Panels';
import Popovers from './layout/Popovers';
import Titlebar from './layout/Titlebar';
import TitlebarMenu from './layout/TitlebarMenu';

// Menus
import RoutePagination from './menus/RoutePagination';
import Tabs from './menus/Tabs';

// Model-specific views
import PostList from './models/PostList';
import PostListItem from './models/PostListItem';

// Pages
import PagePosts from './pages/PagePosts';
import PagePost from './pages/PagePost';
import PageConsole from './pages/PageConsole';
import PageHome from './pages/PageHome';
import PageLogin from './pages/PageLogin';
import PageNoAccess from './pages/PageNoAccess';
import PageNotFound from './pages/PageNotFound';
import PageOffline from './pages/PageOffline';

// Panels
import PanelReadme from './panels/PanelReadme';

// Popovers
import PopoverCounter from './popovers/PopoverCounter';
import PopoverMainMenu from './popovers/PopoverMainMenu';

// Sections
import BlankState from './sections/BlankState';
import FooterSummary from './sections/FooterSummary';
import ScreenTitleArea from './sections/ScreenTitleArea';

// Snippets
import Ellipsis from './snippets/Ellipsis';
import Icon from './snippets/Icon';
import InlineIcon from './snippets/InlineIcon';
import InlineSpinner from './snippets/InlineSpinner';
import Pic from './snippets/Pic';
import PicImg from './snippets/PicImg';
import PicSvg from './snippets/PicSvg';
import Spinner from './snippets/Spinner';
import Tag from './snippets/Tag';

// Transitions
import CustomTransition from './transitions/CustomTransition';
import Fade from './transitions/Fade';
import FadeIn from './transitions/FadeIn';
import FlipVertical from './transitions/FlipVertical';
import ScaleFade from './transitions/ScaleFade';

export {
	App,

	ConsoleComponents,
	ConsoleConfiguration,
	ConsoleModels,
	ConsolePlugins,
	ConsoleServices,
	ConsoleVuex,

	Card,
	Page,
	Panel,
	PanelContent,

	Click,
	ClickButton,
	IconButton,
	Set,
	Slider,
	Textinput,
	Toggle,

	Counter,
	GlobalCounterIterator,
	LocalCounter,

	Checkbox,
	Checkmark,
	Flipswitch,
	Radio,

	Notification,
	Panels,
	Popovers,
	Titlebar,
	TitlebarMenu,

	RoutePagination,
	Tabs,

	PostList,
	PostListItem,

	PagePosts,
	PagePost,
	PageConsole,
	PageHome,
	PageLogin,
	PageNoAccess,
	PageNotFound,
	PageOffline,

	PanelReadme,

	PopoverCounter,
	PopoverMainMenu,

	BlankState,
	FooterSummary,
	ScreenTitleArea,

	Ellipsis,
	Icon,
	InlineIcon,
	InlineSpinner,
	Pic,
	PicImg,
	PicSvg,
	Spinner,
	Tag,

	CustomTransition,
	Fade,
	FadeIn,
	FlipVertical,
	ScaleFade
};

export default {
	App,

	ConsoleComponents,
	ConsoleConfiguration,
	ConsoleModels,
	ConsolePlugins,
	ConsoleServices,
	ConsoleVuex,

	Card,
	Page,
	Panel,
	PanelContent,

	Click,
	ClickButton,
	IconButton,
	Set,
	Slider,
	Textinput,
	Toggle,

	Counter,
	GlobalCounterIterator,
	LocalCounter,

	Checkbox,
	Checkmark,
	Flipswitch,
	Radio,

	Notification,
	Panels,
	Popovers,
	Titlebar,
	TitlebarMenu,

	RoutePagination,
	Tabs,

	PostList,
	PostListItem,

	PagePosts,
	PagePost,
	PageConsole,
	PageHome,
	PageLogin,
	PageNoAccess,
	PageNotFound,
	PageOffline,

	PanelReadme,

	PopoverCounter,
	PopoverMainMenu,

	BlankState,
	FooterSummary,
	ScreenTitleArea,

	Ellipsis,
	Icon,
	InlineIcon,
	InlineSpinner,
	Pic,
	PicImg,
	PicSvg,
	Spinner,
	Tag,

	CustomTransition,
	Fade,
	FadeIn,
	FlipVertical,
	ScaleFade
};



// WEBPACK FOOTER //
// ./src/components/index.js